module.exports = __webpack_public_path__ + "static/media/BasisGrotesqueProWinnowBeta12-Regular.969d22e2.ttf";